import ConfigService from 'common/service/config';

import {
  AuthService,
  CustomerService,
  ServerService,
} from 'common/service/api';

import {
  DeviceService,
  GroupService,
  MeteringProfileService,
  WidgetService,
  TagsService,
  TagsHistoryService,
  WsDeviceService,
  GroupServiceUi,
  JobService,
  JobServiceWS,
} from '../service/api';

export default function configureServices(intl, config) {
  const configService = new ConfigService(config);
  const authService = new AuthService(configService);
  const customerService = new CustomerService(configService);
  const deviceService = new DeviceService(configService);
  const serverService = new ServerService(configService);
  const groupService = new GroupService(configService);
  const meteringProfileService = new MeteringProfileService(configService);
  const widgetService = new WidgetService(configService);
  const tagsService = new TagsService(configService);
  const tagsHistoryService = new TagsHistoryService(configService);
  const wsDeviceService = new WsDeviceService(configService);
  const groupServiceUi = new GroupServiceUi(configService);
  const jobService = new JobService(configService);
  const jobServiceWs = new JobServiceWS(configService);

  return {
    configService,
    authService,
    customerService,
    deviceService,
    serverService,
    groupService,
    meteringProfileService,
    widgetService,
    tagsService,
    tagsHistoryService,
    wsDeviceService,
    groupServiceUi,
    jobService,
    jobServiceWs,
  };
}
